<template>
  <div>
    <PCNavbar selectIndex="13"/>
    <MobileNavBar :currentActive="12" />
    <esgEvaluation/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import esgEvaluation from '@/components/esg_evaluation/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    esgEvaluation
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>